import { PlaygroundState } from '.';
import { DocsPortalStore } from '../../AppStore';
import { createSelector } from '@reduxjs/toolkit';

export const selectPlaygroundState = (state: DocsPortalStore) =>
  state.playground;

export const selectSiteTokenDetails = createSelector(
  [selectPlaygroundState],
  (siteConfigState: PlaygroundState) =>
    siteConfigState.data.selectedSiteTokenDetails,
);
